import {
  ALTERA_PERSONALIZACAO_SUCCESS,
  RECUPERA_PERSONALIZACAO_SUCCESS,
} from './constants';

/* eslint-disable default-param-last */
const initialState = {
  alterado: false,
  dadosPessoais: true,
  residenciais: true,
  beneficiarios: true,
  dependentes: true,
  simularContratar: true,
  contribuicoes: true,
  investimentos: true,
  outros: true,
  requerimentoNovo: true,
  requerimentoEmAndamento: true,
  requerimentoDeferidos: true,
  requerimentoIndeferidos: true,
  simulador: true,
  contracheque: true,
  saldo: true,
  transparencia: true,
  faleConosco: true,
  cardExtratoConta: false,
};

export default function customizaHome(state = initialState, action) {
  switch (action.type) {
    case ALTERA_PERSONALIZACAO_SUCCESS:
      return {
        ...state,
        ...action.values,
        alterado: true,
      };

    case RECUPERA_PERSONALIZACAO_SUCCESS:
      return {
        ...state,
        ...action.values,
        alterado: false,
      };

    default:
      return state;
  }
}
